// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-2-ZMMGZJ","dbox":"dbox-1l9_XM4p"};